import { render } from "./MenuRecobro.vue?vue&type=template&id=30d8444d"
import script from "./MenuRecobro.vue?vue&type=script&lang=js"
export * from "./MenuRecobro.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wServer\\app-pagos-elroble\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__